import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIssueFlag = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#111",
		d: "M17.6 4.6c-.6.2-1.2.4-1.8.4-1.2 0-2.2-.4-3.4-.9C11.1 3.6 9.8 3 8.2 3c-.4 0-.8.1-1.2.1V2H5v20h2v-8.8c.4-.1.8-.2 1.2-.2 1.2 0 2.2.4 3.4.9 1.3.5 2.6 1 4.1 1 .9 0 1.7-.2 2.6-.5l.6-.3V4l-1.3.6zm-.6 8.2c-1.6.4-3.1-.1-4.6-.7-1.3-.5-2.6-1.1-4.2-1.1-.4 0-.8.1-1.2.1V5.2c1.6-.4 3.1.1 4.6.7 1.3.5 2.6 1 4.1 1 .4 0 .8 0 1.2-.1v6h.1z"
	})
});
export default SvgIssueFlag;
